var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle"},_vm._l((_vm.elements),function(element){return _c('button',{key:element.value,staticClass:"toggle__element",class:{
      'active': _vm.selectedValue === element.value,
      'disabled': _vm.disabled,
    },attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('select', element.value)}}},[_vm._v(" "+_vm._s(element.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }